import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export class ApplicationEquipmentItem {

    form: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            manufacturer: ['', Validators.required],
            product: ['', Validators.required],
            unitPrice: ['', Validators.required],
            quantity: ['']
        });
    }

    decode(data: any) {
        this.form.controls.manufacturer.setValue(data.make);
        this.form.controls.product.setValue(data.model);
        this.form.controls.unitPrice.setValue(data.price);
        this.form.controls.quantity.setValue(data.quantity);
    }

    encode(): any {
        return {
            'make': this.form.controls.manufacturer.value,
            'model': this.form.controls.product.value,
            'price': this.form.controls.unitPrice.value,
            'quantity': this.form.controls.quantity.value
        };
    }

    setDefaultData() {
        this.decode({
            make: 'Make1',
            model: 'Model1',
            price: 15000,
            quantity: 1
        });
    }
}
